import { render, staticRenderFns } from "./vuetiform-database-datafield.vue?vue&type=template&id=28874844&scoped=true&"
import script from "./vuetiform-database-datafield.vue?vue&type=script&lang=js&"
export * from "./vuetiform-database-datafield.vue?vue&type=script&lang=js&"
import style0 from "./vuetiform-database-datafield.vue?vue&type=style&index=0&id=28874844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28874844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
